import type { Database } from "../../../../../../__definitions__/database-definitions";
import type { EmailDesign } from "../../../../../email-design/server/supabase-email-design-service";
import type { PollWithOptions } from "../../../../../poll/server/supabase-poll-service";
import type { SlackAlias } from "../../../../../slack/server/slack-supabase-service";

type PublicPreviewMomentData = Database["public"]["Functions"]["moment_preview_data"]["Returns"][0];

/** The same Communication, plus the rows a reviewer's preview is drawn from. */
type ReviewerPreviewMomentData =
  Database["reviewer"]["Functions"]["assigned_moment_preview"]["Returns"][0];

/** A Communication as its preview needs it, from whichever entrance served it. */
export type PreviewMomentData = PublicPreviewMomentData | ReviewerPreviewMomentData;

/** Rows that came with the preview, so the hooks that use them need not read them. */
export interface PreloadedPreviewRows {
  email_design: EmailDesign | null;
  polls: PollWithOptions[] | null;
  slack_alias: SlackAlias | null;
}

/** Undefined when the preview came without them, which only a reviewer's does not. */
export const preloadedPreviewRows = (data: PreviewMomentData): PreloadedPreviewRows | undefined =>
  "email_design" in data
    ? { email_design: data.email_design, polls: data.polls, slack_alias: data.slack_alias }
    : undefined;
